export type Currency = 'INR' | 'USD';

export const CURRENCY_SYMBOL: Record<Currency, string> = { INR: '₹', USD: '$' };

export const RATE_PER_CREDIT: Record<Currency, number> = { INR: 50, USD: 0.5 };

export function formatPrice(amount: string, currency: Currency): string {
  const num = Number(amount);
  if (!Number.isFinite(num)) return `${CURRENCY_SYMBOL[currency]}${amount}`;
  const locale   = currency === 'INR' ? 'en-IN' : 'en-US';
  const decimals = amount.includes('.') ? Math.min(2, (amount.split('.')[1]?.length ?? 0)) : 0;
  return `${CURRENCY_SYMBOL[currency]}${num.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: 2,
  })}`;
}

export function formatMoney(credits: string, currency: Currency): string {
  const n = Number(credits.replace(/^-/, ''));
  if (!Number.isFinite(n)) return '';
  const amount  = n * RATE_PER_CREDIT[currency];
  const locale  = currency === 'INR' ? 'en-IN' : 'en-US';
  const decimals = currency === 'USD' ? 2 : 0;
  return `${CURRENCY_SYMBOL[currency]}${amount.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatCustomPrice(credits: number, currency: Currency): string {
  return formatMoney(String(credits), currency);
}
